export default class CohortMapping {

    mapData(cohort) {
        return {
            id: cohort ? cohort.id : null,
            name: cohort ? cohort.name : null,
            origin: cohort ? cohort.origin : null,
            description: cohort ? cohort.description : null,
            status: cohort ? cohort.status : null,
            owner_id: cohort ? cohort.owner_id : null,
            owner: cohort ? cohort.owner : null,
            learners_count: cohort ? cohort.learners_count : 0,
            instructors_count: cohort ? cohort.instructors_count : 0,
            created_at: cohort ? cohort.created_at : null,
        }
    }

    unmapData(data) {
        return data
    }
}
